import React, { useEffect, useRef, useMemo } from "react";
import { parseRichText } from "../../App/validation/text_helper";
import useDrawInstruction from "../common_hooks/useDrawInstruction";

export default function MAP_CURSOR_INSTRUCTION_FOLLOWER({ children }) {
  
  const cursorRef = useRef(null);
  const drawInstruction = useDrawInstruction();

  /** Cursor follow */
  useEffect(() => {
    const handleMove = (e) => {
      if (cursorRef.current) {
        cursorRef.current.style.transform =
          `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
    };

    window.addEventListener("mousemove", handleMove, { passive: true });

    return () => {
      window.removeEventListener("mousemove", handleMove);
    };
  }, []);

  if (!drawInstruction) return null;

  return (
    <>
      <div
        ref={cursorRef}
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          pointerEvents: "none",
          zIndex: 0,
          willChange: "transform",
        }}
      >
        {children ?? <DefaultCursor drawInstruction={drawInstruction} />}
      </div>
    </>
  );
}

const DefaultCursor = React.memo(({ drawInstruction }) => {
  const content = useMemo(
    () => parseRichText(drawInstruction),
    [drawInstruction]
  );

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        bottom: 15,
        padding: "20px 21px",
        borderRadius: "20px",
        background: "white",
        width: "max-content",
        fontSize: "14px"
      }}
    >
      {content}
    </div>
  );
});